<ion-content [fullscreen]="true" class="ui-2022">
    <div class="header-buttons">
        <i *ngIf="hideCloseButton" (click)="close()" class="ph-x-bold"></i>
    </div>
    <div class="page">
        <div class="heading">
            <i class="{{icon}}"></i>
            <h2 class="title">{{'ui.fullPagePopover.' + title | translate}}</h2>
            <p class="subtitle">{{'ui.fullPagePopover.' + description | translate}}</p>
        </div>

        <div class="action-div">
            <ng-container *ngIf="buttons && buttons.length > 0">
                <ion-button *ngFor="let button of buttons"
                            [color]="button.color? button.color: 'secondary'"
                            [class.btn-link]="!button.type"
                            [fill]="button.type"
                            (click)="button.handler()">
                    {{'ui.fullPagePopover.' + button.label | translate}}
                </ion-button>
            </ng-container>
        </div>
    </div>
</ion-content>
